export interface Permissions {
  // Overall status
  isVIP: boolean;
  subscriptionTier: string;
  subscriptionStatus: string;
  
  // Project-related permissions
  maxProjects: number | 'unlimited';
  maxCollaborators: number | 'unlimited';
  canAccessAllProjects: boolean;
  
  // Feature permissions
  canUseAI: boolean;
  canCreateCustomColumns: boolean;
}

// Default permissions (restrictive)
export const defaultPermissions: Permissions = {
  isVIP: false,
  maxProjects: 3,
  maxCollaborators: 0,
  canAccessAllProjects: false,
  canUseAI: false,
  canCreateCustomColumns: false,
  subscriptionTier: 'free',
  subscriptionStatus: 'inactive',
};
